import { useEffect, useCallback } from 'react';

export interface KeyboardShortcutConfig {
  key: string;
  description: string;
  action: () => void;
  modifier?: 'ctrl' | 'cmd' | 'alt' | 'shift';
  disabled?: boolean;
}

export function useKeyboardShortcutsContext(shortcuts: KeyboardShortcutConfig[]) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.contentEditable === 'true'
      ) {
        if (event.key !== 'Escape') {
          return;
        }
      }

      for (const shortcut of shortcuts) {
        if (shortcut.disabled) continue;

        const modifierMatch =
          !shortcut.modifier ||
          (shortcut.modifier === 'ctrl' && event.ctrlKey) ||
          (shortcut.modifier === 'cmd' && event.metaKey) ||
          (shortcut.modifier === 'alt' && event.altKey) ||
          (shortcut.modifier === 'shift' && event.shiftKey);

        if (
          event.key.toLowerCase() === shortcut.key.toLowerCase() &&
          modifierMatch
        ) {
          event.preventDefault();
          shortcut.action();
          break;
        }
      }
    },
    [shortcuts]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
}
